<template lang="pug">
	.editor-control-select(:class="theme")
		.control-title(v-if="title") {{title}}
		.control-select
			select.custom-select(v-on:change="setValue($event.target.value)")
				option(v-for="(title, key) in values" :value="key" :selected="key === getValue()") {{title}}
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	export default {
		name: 'Select',
		mixins: [Screen],
		screen: {
			updateOn: [
			],
			events: {
			}
		},
		components: {},
		props: ["default", "value", "values", "type", "title", "theme"],
		data() {

			this.element = null;

			return {
				showed: true,
				changedValue: null
			};

		},
		mounted() {

		},
		methods: {
			collectData() {

			},
			getValue() {

				let value = null;

				if (this.changedValue !== null) value = this.changedValue;
				else if (this.value) value = this.value;
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			setValue(value) {

				this.changedValue = this.restoreValueType(value);

				this.sendValue(this.changedValue);

			},
			restoreValueType(value) {

				if (this.type === "number") return parseFloat(value);
				else if (this.type === "string") return value + '';
				else return value;

			},
			sendValue(value) {

				this.$emit('change', value);

			}
		}

	}
</script>

<style lang="sass">

	.editor-control-select
		display: flex
		flex-direction: row
		color: #f3f4f5
		min-height: 31px
		align-items: center

		.control-title
			display: flex
			justify-content: right
			//width: 100px
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.control-select
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			select
				color: #e4e7ea
				background-color: #515b65
				border: 1px solid #23282c

				option:hover
					background-color: #515b65
					box-shadow: 0 0 10px 100px #000 inset
					color: red

	.editor-control-select.dark-mini
		color: #f3f4f5

		.control-select
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			select
				color: #e4e7ea
				background-color: #3e454b
				border: 1px solid rgba(255, 255, 255, 0.09)
				border-radius: 3px
				height: 24px
				padding-top: 0.1rem
				padding-bottom: 0.25rem
				padding-left: 0.5rem
				font-size: 0.765625rem

				option:hover
					background-color: #515b65
					box-shadow: 0 0 10px 100px #000 inset
					color: red

	.editor-control-select.dark-medium
		color: #f3f4f5

		.control-select
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center
			justify-content: left

			select
				color: #e4e7ea
				background-color: #515b65
				border: 1px solid #23282c
				border-radius: 0.25rem
				height: 30px
				padding-top: 0.1rem
				padding-bottom: 0.1rem
				padding-left: 0.5rem
				font-size: 14px
				transition: none

				&:hover
					outline: none
					box-shadow: none
					background-color: #515b65
					border: 1px solid rgba(255, 255, 255, 0.3)

				option:hover
					background-color: #515b65
					box-shadow: 0 0 10px 100px #000 inset
					color: red

</style>
